/** O wa.me exige o número internacional só com dígitos. O telefone da empresa é salvo sem o 55. */
export function whatsappPhone(phone: string | null | undefined): string {
  const digits = (phone || '').replace(/\D/g, '');
  return digits.length <= 11 ? `55${digits}` : digits;
}

export function whatsappUrl(phone: string | null | undefined, message?: string): string {
  const url = `https://wa.me/${whatsappPhone(phone)}`;
  return message ? `${url}?text=${encodeURIComponent(message)}` : url;
}
